import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import * as error from '../../shared/components/error-summary/error-handler.function';

@Injectable()
export class PaymentService {

  constructor(private http: Http) { }

  createPayment = (options: CreatePaymentOptions) => {
    const url = `/umbraco/api/payment/createpayment`;
    return this.http.post(url, options)
      .map(this.extractJson)
      .catch(error.handleError);
  }

  confirmAndTicket = (options: ConfirmAndTicketOptions) => {
    const url = `/umbraco/api/payment/confirmpayment`;
    return this.http.post(url, options)
      .map(this.extractJson)
      .catch(error.handleError);
  }

  private extractJson(res: Response) {
    let body = res.json();
    return body;
  }
}


export class CreatePaymentOptions {
  constructor(
    private PaymentMethod: string,
    private PaymentContext: string,
    private BookingGuid: string) {
  }

  Amount: number;
  TransactionReference: string;
  PaymentDescription: string;
  ItemList: Array<any>;
  CancelUrl: string;

}

export class CreatePaymentResult{
  public merchant: string;
  public result: string;
  public session: string;
  public Message: string;
}

export class TnsCreditCardOptions {
  constructor(
      private cardNumber: string,
      private cardSecurityCode: string,
      private cardExpiryMonth: string,
      private cardExpiryYear: string
  ) {}
}

export class TnsResponse {
  status: string;
  cardFundingMethod: string;
  cardScheme: string;
  cardBrand: string;
  session: string;
  cardData: Array<CardData>;
  fieldsInError: any;
}

export class CardData{
  cardExpiryMonth: number;
  cardExpiryYear: number;
  cardNumber: string;
}

export class ConfirmAndTicketOptions {
  constructor(private bookingGuid: string, private Tns: TnsOptions, private Loyalty: LoyaltyOptions) {}
}

export class TnsOptions {
  constructor(private TransactionNumber: string, private FormSession: string, private TransactionAmount:  number){}
}

export class LoyaltyOptions {
  constructor(private customerId: string){}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/payment.service.ts